<template>
  <div class="keywords-dictionary">
    <SettingsBlock title="Keywords dictionary">
      <div class="main">
        <div class="add-new-keyword-section">
          <header>
            <img :src="DictionaryAddIcon" alt="" class="dictionary-add-icon" />
            <h2>New keyword</h2>
          </header>
          <p class="subtitle">
            Add a word to your dictionary. This will help make the AI captions
            more accurate!
          </p>
          <InputText
            class="text-input-field"
            id="keyword"
            type="text"
            v-model="newKeyword"
            placeholder="Enter a keyword"
          />
          <div class="definition-input form-input">
            <label for="definition">Definition (Optional)</label>
            <Textarea
              class="input-field text-input-field"
              id="definition"
              v-model="newKeywordDefinition"
              placeholder="Definition"
              :autoResize="true"
              rows="3"
            />
          </div>
          <!-- <div class="save-to-database-input form-input">
          <label for="database">Save to database</label>
          <Select
            class="input-field dropdown-menu"
            id="database"
            v-model="newKeywordSubject"
            :options="subjects"
            optionLabel="subjectName"
            placeholder="Subject"
          />
        </div> -->
          <RoundedButton
            text="Add"
            @click="addKeyword"
            accent
            lessRound
            fitWidth
            class="add-keyword-button"
          />
          <!-- <UnderlinedButton
            text="Or import data from Excel, CSV or JSON"
            accent
            big
            class="import-button"
            v-tooltip.top="'Coming soon'"
            disabled
          /> -->
        </div>
        <div class="keywords-list-section">
          <header>
            <h2>Keywords list</h2>
          </header>
          <div
            v-for="keyword in keywords"
            v-bind:key="keyword.word"
            class="keywords-list-item"
          >
            <div class="keyword">
              <div class="keywords-list-word">{{ keyword.value }}</div>
              <div class="keywords-list-definition">
                {{ keyword.definition }}
              </div>
            </div>
            <button
              class="delete-button"
              @click="deleteKeywordFromDictionary(keyword.value)"
            >
              <img :src="CloseIcon" alt="" />
            </button>
          </div>
        </div>
      </div>
    </SettingsBlock>
  </div>
</template>

<script>
import RoundedButton from "../RoundedButton";
import DictionaryAddIcon from "../../assets/images/DictionaryAdd.svg";
import CloseIcon from "../../assets/images/Close.svg";
import SettingsBlock from "./SettingsBlock";

export default {
  components: {
    RoundedButton,
    SettingsBlock,
  },

  props: {
    closeSettings: Function,
    setShowSettingsMainMenu: Function,
    keywords: Array,
    addKeywordToDictionary: Function,
    deleteKeywordFromDictionary: Function,
  },

  data() {
    return {
      DictionaryAddIcon,
      CloseIcon,

      newKeyword: null,
      newKeywordDefinition: null,
      newKeywordSubject: null,
      subjects: [{ subjectName: "GEO101" }, { subjectName: "PHL245" }],
    };
  },

  methods: {
    addKeyword() {
      this.addKeywordToDictionary(this.newKeyword, this.newKeywordDefinition);
      this.newKeyword = null;
      this.newKeywordDefinition = null;
    },
  },
};
</script>

<style lang="scss">
.keywords-dictionary {
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  max-height: 100vh;
  color: map-get($colours, white);

  .main {
    flex: 1;
    overflow: auto;

    h2 {
      font-size: 1.6rem;
      font-family: $font-default;
      font-weight: bold;
      margin: 0;
    }

    .dictionary-add-icon {
      width: 2.8rem;
    }

    .add-new-keyword-section {
      padding: 0.8rem 0 2.4rem;
      border-bottom: 1px solid map-get($component-colours, border-light);
      display: flex;
      flex-direction: column;
      align-items: stretch;

      header {
        display: flex;
        align-items: center;

        img {
          margin-right: 1rem;
        }
      }

      .subtitle {
        color: map-get($component-colours, grey-3);
        margin: 0.8rem 0 1.6rem;
      }

      .text-input-field {
        font-size: 1.4rem;
        padding: 1.2rem;
        color: map-get($colours, grey-1);
      }

      .form-input {
        label {
          display: block;
          width: 100%;
          font-size: 1.6rem;
          margin-top: 1.6rem;
        }

        .input-field {
          width: 100%;
          margin-top: 0.8rem;
          color: map-get($colours, grey-1);
        }

        .dropdown-menu {
          .p-inputtext {
            font-size: 1.6rem;
          }
        }
      }
      .definition-input {
      }

      .add-keyword-button {
        margin-top: 1.6rem;
      }

      .import-button {
        margin-top: $side-panel-outside-padding;
      }
    }

    .keywords-list-section {
      padding-top: $side-panel-outside-padding;

      header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.8rem;
      }

      .keywords-list-item {
        font-size: 1.6rem;
        padding: 0.8rem 1.2rem;
        display: flex;
        border-radius: 0.4rem;
        justify-content: space-between;
        align-items: center;

        &:hover {
          background-color: darken(
            map-get($component-colours, chat-background),
            5%
          );

          .delete-button {
            display: inline-block;
          }
        }

        .keywords-list-word {
        }

        .keywords-list-definition {
          margin-top: 0.4rem;
          color: map-get($component-colours, keyword-definition);
        }

        .delete-button {
          display: none;
          padding: 0;
          border-radius: 50%;
          line-height: 0;
          width: 2.5rem;
          height: 2.5rem;
          background-color: transparent;

          &:hover {
            img {
              transform: scale(1.3);
            }
          }

          img {
            transform-origin: center;
            transition: transform 0.2s;
            width: 65%;
            height: 65%;
          }
        }
      }
    }
  }
}
</style>
